/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: find out any for new consumer search data
import { Product } from '@goatapp/protos-gen-node/buying/consumer_search/api/v1/server_pb'
import { SearchHit } from 'layout/navigation/search/SearchMenu'
import getConfig from 'next/config'
import { ProductDataItem } from 'shared/types/ConsumerSearch'

export const CS_FILTER_KEYS = [
  'brand_name',
  'silhouette',
  'color',
  'single_gender',
  'product_category',
  'shoe_condition',
  'designer',
  'activity',
  'collection_slugs',
] as const

export type CSFilterKey = (typeof CS_FILTER_KEYS)[number]

export const redirectRoutesFilters: any = {
  'adidas-yeezy': {
    silhouette: ['yeezy'],
    brand: ['adidas'],
  },
  'nike-yeezy': {
    silhouette: ['yeezy'],
    brand: ['nike'],
  },
  'foam-runner': {
    collection: 'yeezy-foam-runner',
  },
  slides: {
    collection: 'yeezy-slides',
  },
  'nike-basketball': {
    activity: ['basketball'],
    brand: ['nike'],
  },
  'nike-cross-training': {
    activity: ['cross-training'],
    brand: ['nike'],
  },
  'nike-running': {
    activity: ['running'],
    brand: ['nike'],
  },
  'nike-skateboarding': {
    activity: ['skateboarding'],
    brand: ['nike'],
  },
}
export const getSearchForSlug = (slug: string) => {
  if (slug === 'men' || slug === 'women' || slug === 'youth') {
    return {
      gender: [slug],
    }
  }

  if (slug === 'new-releases') {
    return {
      collection: 'new-releases',
    }
  }

  if (slug === 'apparel') {
    return {
      category: ['apparel'],
    }
  }

  if (slug === 'sneakers') {
    return {}
  }

  if (slug === 'sneakers-under-250') {
    return {
      pricemax: '25000',
    }
  }

  if (slug === 'sneakers-under-350') {
    return {
      pricemax: '35000',
    }
  }

  if (slug === 'price-drops') {
    return {
      collection: 'price-drops',
    }
  }

  if (slug === 'pre-owned') {
    return {
      collection: 'pre-owned',
    }
  }

  return undefined
}

export const toAlgoliaSearchProduct = (data: Product.AsObject[] = []) => {
  return data.map((item: Product.AsObject) => {
    const newData = {} as SearchHit
    newData.grid_picture_url = item.pictureUrl
    newData.name = item.title
    newData.slug = item.slug

    return newData as SearchHit
  })
}

export const toAlgoliaProductHit = (data: Product.AsObject[] = []) => {
  const { publicRuntimeConfig } = getConfig()

  return data.map<ProductDataItem>((item: Product.AsObject) => ({
    brandName: item.brandName,
    id: item.id,
    name: item.title,
    pictureUrl: item.pictureUrl || publicRuntimeConfig.IMAGE_FC_CDN + 'missing.png?w:360',
    price: {
      localizedValue:
        item?.variantsList?.[0]?.localizedLowestPriceCents?.amountCents !== undefined
          ? (item?.variantsList?.[0]?.localizedLowestPriceCents?.amountCents || 0) / 100
          : null,
    },
    slug: item.slug,
  }))
}

export const getCSFilters = (filters?: Record<string, string[]>) => {
  if (!filters || typeof filters !== 'object') {
    return {}
  }

  if (filters['category'] && !filters['activity']) {
    filters['activity'] = filters['category'].map((s) => s.toLowerCase())
  }

  return Object.fromEntries(
    Object.entries(filters).filter(([key]) => CS_FILTER_KEYS.includes(key as CSFilterKey)),
  )
}
